import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import { integrationMaxWidth } from "app/pages/sales-intelligence/pages/manage-export/style";

export const StyledFooterWrapper = styled(Flex)`
    width: 100vw;
    margin-left: calc(-50vw + 50%);
`;

export const StyledFooterContent = styled(Flex)`
    ${integrationMaxWidth}
`;
